import { render } from "./GuestsList.vue?vue&type=template&id=b983a692&scoped=true"
import script from "./GuestsList.vue?vue&type=script&lang=js"
export * from "./GuestsList.vue?vue&type=script&lang=js"

import "./GuestsList.vue?vue&type=style&index=0&id=b983a692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b983a692"]])

export default __exports__